import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';

const MatrixCanvas = styled.canvas`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
`;

const MatrixBackground = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const container = canvas.parentElement;

    let w, h;
    let columns;
    let yPos;

    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const fontSize = 16;

    const setupCanvas = () => {
      w = canvas.width = container.offsetWidth;
      h = canvas.height = container.offsetHeight;
      
      columns = Math.floor(w / fontSize);
      yPos = Array(columns).fill(0).map(() => Math.random() * h);
      
      ctx.fillStyle = '#0A0A0A';
      ctx.fillRect(0, 0, w, h);
    };

    const matrix = () => {
      ctx.fillStyle = 'rgba(10, 10, 10, 0.05)';
      ctx.fillRect(0, 0, w, h);

      ctx.fillStyle = '#39ff14';
      ctx.font = `${fontSize}px monospace`;

      yPos.forEach((y, ind) => {
        const text = chars[Math.floor(Math.random() * chars.length)];
        const x = ind * fontSize;
        ctx.fillText(text, x, y);

        if (y > h && Math.random() > 0.975) {
          yPos[ind] = 0;
        } else {
          yPos[ind] = y + fontSize;
        }
      });
    };

    let lastTime = 0;
    let timer = 0;
    const fps = 20;
    const nextFrame = 1000 / fps;
    let animationFrameId;

    const animate = (timeStamp = 0) => {
      const deltaTime = timeStamp - lastTime;
      lastTime = timeStamp;

      if (timer > nextFrame) {
        matrix();
        timer = 0;
      } else {
        timer += deltaTime;
      }
      
      animationFrameId = requestAnimationFrame(animate);
    };
    
    const resizeObserver = new ResizeObserver(() => {
      cancelAnimationFrame(animationFrameId);
      setupCanvas();
      animate(0);
    });

    if (container) {
      resizeObserver.observe(container);
    }
    
    setupCanvas();
    animate(0);

    return () => {
      cancelAnimationFrame(animationFrameId);
      if (container) {
        resizeObserver.unobserve(container);
      }
    };
  }, []);

  return <MatrixCanvas ref={canvasRef} />;
};

export default MatrixBackground; 